import gql from 'graphql-tag';

export const MyExamScoreFragment = gql`
  fragment MyExamScoreFragment on MyExamScore {
    id
    examId
    examScore
  }
`;

export const ExamTopicDetailsFragment = gql`
  fragment ExamTopicDetailsFragment on Exam {
    id
    topicsRemarks
    topics {
      id
      topicName
      numChoices
      numPercent
      recommended
    }
  }
`;
export const ExamShortFragment = gql`
  fragment ExamShortFragment on Exam {
    id
    fullName
    examGroupName
    icon
  }
`;

export const ExamDetailsFragment = gql`
  fragment ExamDetailsFragment on Exam {
    description
    applicationDate {
      startDate
      endDate
    }
    examDate {
      startDate
      endDate
    }
    resultDate
    totalQuestion
    fullScore
    duration
  }
`;
